/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník orientací obrazovky.
 * @enum {string}
 * @name OrientationEnum
 */
export default {
  CLOCKWISE_0: 'CLOCKWISE_0',
  CLOCKWISE_90: 'CLOCKWISE_90',
  CLOCKWISE_180: 'CLOCKWISE_180',
  CLOCKWISE_270: 'CLOCKWISE_270',
  UNKNOWN: 'UNKNOWN'
};
